import React, { useEffect, useRef, useState } from 'react';
import { EnsPageLoader } from './EnsLoader';
import { useBootVisible } from './bootHold';

const FADE_MS = 400;

/**
 * Renders the boot splash once while any startup gate is holding it. When the
 * hold releases the app is already rendered underneath; the splash only lingers
 * (non-interactive, aria-hidden) for the fade, then unmounts.
 */
export const BootHost: React.FC = () => {
  const visible = useBootVisible();
  const shown = useRef(visible);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    if (visible) {
      shown.current = true;
      setFading(false);
      return;
    }
    if (!shown.current) return;
    shown.current = false;
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
    setFading(true);
    const t = window.setTimeout(() => setFading(false), FADE_MS);
    return () => window.clearTimeout(t);
  }, [visible]);

  // Same element in both states so the DOM node persists and the opacity transition runs.
  return visible || fading ? <EnsPageLoader label="Loading EnsoMirai++…" hiding={!visible} /> : null;
};

/** Full-screen boot mark. Unmount it when the app is ready. */
const EnsoBootLoader: React.FC = () => <EnsPageLoader label="Loading EnsoMirai++…" />;

export default EnsoBootLoader;
